module.exports = __webpack_public_path__ + "img/apple_pay.2d868d87.png";